/* src/app/components/lead-details/summary/lead-detail-summary-training-tile/lead-detail-summary-training-tile.component.css */
.view-welcome-letter {
  width: 100px;
  color: white;
}
.view-welcome-letter:focus-visible {
  outline: var(--focus-outline);
  outline-offset: 2px;
}
.button-container {
  display: flex;
  justify-content: space-evenly;
}
.summary-heading {
  background-color: #bebdf575;
  padding: 4px;
  border-radius: 4px;
  font-size: 1.286rem;
  margin-bottom: 10px;
  margin-top: 0;
  font-weight: 500;
}
/*# sourceMappingURL=lead-detail-summary-training-tile.component-HWH35UD7.css.map */
